import {AppDialog} from 'components/dialogs';
import {AppSprintSelect} from 'components/form';
import {useMoveItemToSprint} from 'hooks';
import {useAlert} from 'hooks/useAlert';
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import {BoardTableViewActionsCommonProps} from '../TableViewMultiRowSelectedActions';
import ActionsTitle from './ActionsTitle';
interface BoardViewUpdateSprintDialogProps extends BoardTableViewActionsCommonProps {}
export const BoardViewUpdateSprintDialog: React.FC<BoardViewUpdateSprintDialogProps> = ({
    selectedRows,
    onClose,
    open,
}) => {
    const {control, handleSubmit} = useForm<{sprintId: string}>({defaultValues: {sprintId: ''}});
    const {boardId} = useParams();
    const {moveItemToSprint, moveItemToSprintLoading, moveItemToSprintResponse} = useMoveItemToSprint(true);
    const {invokeSuccessMessage} = useAlert();
    useEffect(() => {
        if (moveItemToSprintResponse && !moveItemToSprintLoading) {
            invokeSuccessMessage(`The sprint successfully updated.`);
            onClose(true);
        }
    }, [moveItemToSprintResponse, moveItemToSprintLoading]);

    const onSubmitHandler = (data: {sprintId: string}) => {
        if (selectedRows.length > 0 && data.sprintId) {
            moveItemToSprint({
                variables: {
                    input: {
                        sprintId: data.sprintId,
                        itemIds: selectedRows.map(item => item.id),
                    },
                },
            });
        }
    };

    return (
        <>
            <AppDialog
                isForm={true}
                onFormSubmit={handleSubmit(onSubmitHandler)}
                open={open}
                title={<ActionsTitle title="Update Sprint" selectedRows={selectedRows} />}
                fullWidth
                maxWidth="sm"
                footerProps={{
                    onCancelClick: () => onClose(false),
                    submitButtonProps: {
                        type: 'submit',
                        isLoading: moveItemToSprintLoading,
                        disabled: moveItemToSprintLoading,
                    },
                }}
                onCloseDialog={() => onClose(false)}
                children={
                    <div>
                        <AppSprintSelect
                            disableClearable={true}
                            shouldReturnValueOnly
                            fullWidth
                            required={true}
                            label="Select Sprint"
                            boardSlug={boardId}
                            name="sprintId"
                            control={control}
                        />
                    </div>
                }
            />
        </>
    );
};

export default BoardViewUpdateSprintDialog;
